import { render, staticRenderFns } from "./InvD_Total.vue?vue&type=template&id=dcadbd92"
import script from "./InvD_Total.vue?vue&type=script&lang=js"
export * from "./InvD_Total.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports